<template>
  <div>
    <div class="prize" v-if="showPrize">积分 <span>+1</span> 啦</div>
    <div class="bg" v-if="showPrize"></div>
  </div>
</template>

<script>
export default {
  name: 'wx-share',
  data () {
    return {
      showPrize: false
    }
  },
  props: ['shareTile', 'shareDesc', 'shareImg', 'shareUrl'],
  mounted () {
    this.showPrize = false
    this.weConfig()
  },
  methods: {
    weConfig () {
      let paramurl = ''
      if (this.shareUrl) {
        paramurl = this.shareUrl
      } else {
        this.shareImg = 'https://www.91sami.com/static/logo_square.png'
        paramurl = window.location.href
        if (paramurl === this.baseHome) {
          paramurl = this.baseHome + '/'
        }
      }

      this.$axios.get(process.env.BASE_API + '/user/wxsign', {
        params: {
          url: paramurl
        }
      })
        .then(res => {
          const data = res.data.datas.weConfig
          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['onMenuShareAppMessage']
          })
          wx.ready(() => {
            wx.onMenuShareAppMessage({
              title: this.shareTile, // 分享标题
              desc: this.shareDesc, // 分享描述
              link: paramurl,
              // link: this.shareUrl ? this.shareUrl : this.baseHome + '/', // 分享链接00
              imgUrl: this.shareImg, // 分享图标
              // 用户确认分享后执行的回调函数
              success: () => {
                let operation = ''
                if (this.shareUrl.indexOf('bargain') > -1) {
                  operation = 'bargain'
                } else if (this.shareUrl.indexOf('pintuanDetail') > -1) {
                  operation = 'shareGoods'
                }
                if (operation && sessionStorage.getItem('access-token')) {
                  this.$operationAction(operation)
                }
                this.$toast({
                  message: '分享成功',
                  iconClass: 'icon icon-success'
                })
                if (this.shareUrl.indexOf('smallproduc') > 0) {
                  sessionStorage.setItem('wxShareSuc', '1')
                }
                this.getfanpai(1)
                // if (operation === 'shareGoods') {
                //   this.$axios.get('/newyear/share').then(res => {
                //     if (!res.data.ret) {
                //       this.getFuka(1)
                //     }
                //   })
                // }
                // else if (this.shareUrl.indexOf('takeKeyInvite') > 0) {
                //   this.$axios.get('/box/getkey', {
                //     params: {
                //       getType: 1
                //     }
                //   }).then(res => {
                //     let data = res.data.datas
                //     data.boxKey ? this.$toast('获取青铜钥匙一枚，可在宝箱页面查看！') : ''
                //   })
                // } else if (this.shareUrl.indexOf('product') > 0) {
                //   this.$axios.get('/product/share').then(res => {
                //     if (res.data.ret === 0) {
                //       this.$toast({
                //         message: '分享成功',
                //         iconClass: 'icon icon-success'
                //       })
                //       this.showPrize = true
                //       setTimeout(() => {
                //         this.showPrize = false
                //       }, 1000)
                //     } else {
                //       this.$toast({
                //         message: res.data.msg
                //       })
                //     }
                //   })
                // }
              },
              cancel: () => {
                // 用户取消分享后执行的回调函数
              }
            })
          })
        })
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
  .bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 999;
  }
  .prize {
    position: fixed;
    top: 35%;
    left: 50%;
    transform: translate(-50%);
    z-index: 9999;
    color: #fff;
    font-size: 32px;
    span {
      color: #d5a872;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wxShare/wxShare.vue